import { render, staticRenderFns } from "./SubSector.vue?vue&type=template&id=370e0a7f"
import script from "./SubSector.vue?vue&type=script&lang=js"
export * from "./SubSector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports